import React, { useState, useEffect, useRef } from "react";
import "./departmentPrice.css";
import Component from "../../Components";
import { useSelector, useDispatch } from "react-redux";
import { resetScroll } from "../../modules/scrollToTop/scrollAction";
import strings from "../../utils/strings";
import { useNavigate } from "react-router-dom";

const DepartmentPrice = () => {
  const [selectedView, setSelectedView] = useState("departmentPrice");
  const [priceToEdit, setPriceToEdit] = useState(null);
  const shouldScrollToTop = useSelector((state) => state.scroll.shouldScrollToTop);
  const topRef = useRef(null);
  const dispatch = useDispatch();

    const nav = useNavigate();
    const privilege = useSelector((state) => state.verifyType.privilege);
    useEffect(() => {
      switch (true) {
        case privilege.hasDepartmentRight:
          nav(strings.navigation.departmentPrice);
          break;
        case privilege.hasTNCright:
          nav(strings.navigation.termsCondition);
          break;
        case privilege.hasPatientProfileRight:
          nav(strings.navigation.patientProfile);
          break;
        case privilege.hasNationalIdRight:
          nav(strings.navigation.nationalID);
          break;
        case privilege.hasArticleRight:
          nav(strings.navigation.healthArticle);
          break;
      }
    }, [privilege]);

  useEffect(() => {
    if (shouldScrollToTop) {
      if (topRef.current) {
        topRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        const timer = setTimeout(() => {
          dispatch(resetScroll());
        }, 1);

        return () => clearTimeout(timer);
      }
    }
  }, [shouldScrollToTop, dispatch]);

  const handleDepartmentPriceSelect = (department) => {
    setPriceToEdit(department);
    setSelectedView("editDepartmentPrice");
  };

  return (
    <div className="dp-container" ref={topRef}>
      {selectedView === "departmentPrice" && <Component.DepartmentPriceList setSelectedView={setSelectedView} onDepartmentSelect={handleDepartmentPriceSelect} />}
      {selectedView === "addDepartmentPrice" && <Component.AddDepartmentPrice setSelectedView={setSelectedView} />}
      {selectedView === "editDepartmentPrice" && <Component.EditDepartmentPrice setSelectedView={setSelectedView} data={priceToEdit} />}
    </div>
  );
};

export default DepartmentPrice;
